import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import AdminLayout from '../components/AdminLayout.jsx';
import { api, uploadUrl } from '../../api/client.js';
import { Swal2 } from '../../lib/swal.js';
import { MORPH_BTN } from '../../lib/ui.js';

const empty = { nama: '', peran: '', review: '', rating: 5, is_active: true };

export default function TestimonialForm() {
  const { id } = useParams();
  const isEdit = !!id;
  const navigate = useNavigate();
  const [form, setForm] = useState(empty);
  const [file, setFile] = useState(null);
  const [preview, setPreview] = useState('');
  const [error, setError] = useState('');
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (isEdit) {
      api.get(`/admin/testimonial/${id}`).then(({ data }) => {
        setForm({ ...data.item, is_active: !!data.item.is_active });
        setPreview(data.item.avatar ? uploadUrl(data.item.avatar) : '');
      });
    }
  }, [id]);

  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));
  const onFile = (e) => {
    const f = e.target.files[0];
    setFile(f);
    if (f) setPreview(URL.createObjectURL(f));
  };

  const submit = async (e) => {
    e.preventDefault();
    setSaving(true);
    setError('');
    try {
      const fd = new FormData();
      Object.entries(form).forEach(([k, v]) => { if (k !== 'avatar' && k !== 'id' && k !== 'source' && k !== 'email') fd.append(k, v); });
      if (file) fd.append('avatar', file);
      if (isEdit) await api.put(`/admin/testimonial/${id}`, fd);
      else await api.post('/admin/testimonial', fd);
      Swal2.toast('success', isEdit ? 'Berhasil diperbarui.' : 'Berhasil ditambahkan.');
      navigate('/admin/testimonial');
    } catch (err) {
      setError(err.response?.data?.message || 'Gagal menyimpan.');
    } finally {
      setSaving(false);
    }
  };

  const inputCls = 'w-full px-4 py-3 rounded-xl border text-sm outline-none bg-neutral-50 dark:bg-neutral-800 dark:text-white border-neutral-200 dark:border-neutral-700 focus:border-forest-500 focus:ring-2 focus:ring-forest-500/20';
  const labelCls = 'block text-xs font-bold text-neutral-500 uppercase tracking-wider mb-1.5';

  return (
    <AdminLayout title={isEdit ? 'Edit Testimonial' : 'Tambah Testimonial'}>
      <form onSubmit={submit} className="max-w-2xl bg-white dark:bg-neutral-900 rounded-2xl border border-black/5 dark:border-white/5 p-6 space-y-4">
        {error && <div className="p-3 rounded-xl text-sm font-semibold bg-red-50 text-red-600 dark:bg-red-950/30">{error}</div>}

        <div className="grid grid-cols-2 gap-4">
          <div>
            <label className={labelCls}>Nama</label>
            <input required className={inputCls} value={form.nama} onChange={set('nama')} />
          </div>
          <div>
            <label className={labelCls}>Peran / Institusi</label>
            <input className={inputCls} value={form.peran || ''} onChange={set('peran')} />
          </div>
        </div>
        <div>
          <label className={labelCls}>Ulasan</label>
          <textarea required rows={4} className={`${inputCls} resize-none`} value={form.review} onChange={set('review')} />
        </div>
        <div>
          <label className={labelCls}>Rating</label>
          <div className="flex gap-1">
            {[1, 2, 3, 4, 5].map((r) => (
              <button type="button" key={r} onClick={() => setForm((f) => ({ ...f, rating: r }))}>
                <span className="material-symbols-outlined text-2xl" style={{ color: '#FFC72C', fontVariationSettings: `'FILL' ${r <= form.rating ? 1 : 0}` }}>star</span>
              </button>
            ))}
          </div>
        </div>
        <div>
          <label className={labelCls}>Foto (opsional)</label>
          {preview && <img src={preview} className="w-16 h-16 object-cover rounded-full mb-2" />}
          <input type="file" accept="image/*" onChange={onFile} className="text-sm text-neutral-500" />
        </div>
        <label className="flex items-center gap-2 text-sm font-semibold text-neutral-700 dark:text-white">
          <input type="checkbox" checked={form.is_active} onChange={(e) => setForm((f) => ({ ...f, is_active: e.target.checked }))} className="w-4 h-4 accent-forest-500" />
          Tampilkan testimonial ini
        </label>

        <div className="flex gap-3 pt-2">
          <button disabled={saving} type="submit" className={`px-6 py-3 rounded-xl font-bold text-white text-sm ${MORPH_BTN}`} style={{ background: 'var(--accent)' }}>{saving ? 'Menyimpan...' : 'Simpan'}</button>
          <button type="button" onClick={() => navigate('/admin/testimonial')} className={`px-6 py-3 rounded-xl font-bold text-sm bg-neutral-100 dark:bg-neutral-800 text-neutral-600 dark:text-white ${MORPH_BTN}`}>Batal</button>
        </div>
      </form>
    </AdminLayout>
  );
}
